import { Helmet } from "react-helmet";
import DataChartsSection from "../../components/admin-pages/infographics/data-charts-section/DataChartsSection";
import InfoGraphCounterSection from "../../components/admin-pages/infographics/info-graph-counter-section/InfoGraphCounterSection";
import InformationsCounterSection from "../../components/admin-pages/infographics/informations-counter-section/InformationsCounterSection";

const Infografics = () => {
  return (
    <div id="pages">
      <Helmet>
        <title>Orhan Door | Admin Statistika</title>
      </Helmet>
      <div className="page_head">
        <h1 className="page_title">Statistika</h1>
      </div>
      <InformationsCounterSection />
      <InfoGraphCounterSection />
      <DataChartsSection />
    </div>
  );
};

export default Infografics;
